import React from "react";


import Button from "../Button";
import firebase from 'firebase/compat/app';
import { useAuthState } from "../widgets/hooks";
import db from "../../firebase";


export default function Navbar() {
    const { user } = useAuthState(firebase.auth());
    const signInWithGoogle = async () => {
        // Retrieve Google provider object
        const provider = new firebase.auth.GoogleAuthProvider();
        // Set language to the default browser preference
        firebase.auth().useDeviceLanguage();
        // Start sign in process
        try {
          await firebase.auth().signInWithPopup(provider).then(result => {
            db.collection("users").add({
              username: result.additionalUserInfo.profile.given_name,
              name : result.user.displayName,
              photo: result.user.photoURL,
              email: result.user.email,
              uid: result.user.uid,
            });
          });
        } catch (error) {
          console.log(error.message);
        }
      };
      const signOut = async () => {
        try {
          await firebase.auth().signOut();
        } catch (error) {
          console.log(error.message);
        }
      };
    return (
        <nav className="bg-green-400 p-5 flex justify-between">
            {
                user ? (
                  <div>  
                    <img src={user.photoURL} alt={user.displayName} className="w-12 h-12 mx-auto rounded-full " />
                    <p className="text-white">Hii, {user.displayName}</p>
                  </div>
                ) : <> </>
            }
            
            
            <div className="text-center">
                <h1 className="text-white font-bold text-3xl">
                    BatCheet
                </h1>
                <p className="text-white">Real-Time Chat App</p>
            </div>
            <div>
            {
                user ? (
                <>  
                    <Button onClick={signOut} >Sign out</Button>
                </>
                ) : <Button onClick={signInWithGoogle}>Sign in with Google</Button> 
            }
            </div>
            
            
        </nav>
    )
}